import {capitalizeAndSpace, readableDate, classNames} from '../../component/Helper'
import { useNavigate } from 'react-router-dom';
import { API_CONFIG, sendPostRequest } from '../../helper/HttpHelper'
import { CreateForm } from '../../component/Form'
import { AuthContext } from '../../store/auth-context';
import { useState, useContext, useEffect } from 'react';

const form = {
    'body': [
        { type: 'FTTitle',  field:'form_title', title: 'Trade Finance Loan Application', subtitle: 'Please upload your invoice and loan requirement details'},  
        { type: 'FTDynamicSelect', required: true, label: 'Supplier', field: 'supplier', fetch: {'endpoint':  API_CONFIG.API_BASE_URL + 'retailer/listCommon', 'method':'EnterpriseType#supplier', 'key': 'business_name'}},
        { type: 'FTTextInput', required: true, field: 'performa_invoice_no', label: 'Performa Invoice No' },
        { type: 'FTTextInput', required: true, inputType: 'date', field: 'performa_invoice_date', label: 'Performa Invoice Date'},
        { type: 'FTTextInput', required: true, field: 'performa_invoice_amount', label: 'Performa Invoice Amount(In Rs.)', placeholder: 'eg. 12345.56', error:['Please enter valid invoice amount'], validator:['isFloat']},
        { type: 'FTTextInput', required: true, field: 'funding_expected', label: 'Funding Expected Amount( In Lakhs)', placeholder: 'eg. 4', error:['Please enter valid funding amount'], validator:['isNumeric']},
        { type: 'FTSelect', label: 'Expected Loan Tenure( In Months)', field: 'expected_loan_tenure', 
            options:[{l:'1', k:'1'},{l:'2', k:'2'},{l:'3', k:'3'},{l:'4', k:'4'},{l:'5', k:'5'}]
        },
        { type: 'FTTextInput', required: true, inputType: 'date', field: 'target_date', label: 'Target Date for securing Loan'},
        { type: 'FTButton', title: 'Submit', field: 'submit_button'}
    ],
    'submit':{ 'endpoint': API_CONFIG.API_BASE_URL + 'retailer/add', 'method':'LoanAppId#{{aid}}', 'getpoint': API_CONFIG.API_BASE_URL + 'retailer/get'}
}
const statuses = {
    Complete: 'text-green-700 bg-green-50 ring-green-600/20',
    'In progress': 'text-gray-600 bg-gray-50 ring-gray-500/10',
    Archived: 'text-yellow-800 bg-yellow-50 ring-yellow-600/20',
  }
 function ListLoanScreen() {
    const [loanApplications, setLoanApplications] = useState([])
    const {token, loading, logout} = useContext(AuthContext);
    const authContext = useContext(AuthContext);

    useEffect(() => {
        const fetchLoanApplication = async () => {
          let res = await sendPostRequest(API_CONFIG.API_BASE_URL + 'retailer/list', { 'token': token, 'eid': token.eid, 'method': 'LoanAppId#' } ) 
           setLoanApplications(res.data)
          console.log(res)
        }
        try{
            fetchLoanApplication()  
        }catch(e){
          console.error(e)
        }
    }, [])
    const navigate = useNavigate()
    function handleClick(loanApplication) {
        //console.log(JSON.stringify(loanApplication));
        navigate(`/home/loanDetail/${loanApplication.ATTR1.loan_id}`)
    }
    const getLabel = (fieldName) => {
        console.log(fieldName);
        const row = form.body.find((row) => row.field === fieldName);
        return row ? row.label : '';
    };
    const renderChunks = (loanApplication) => {
        const attributes = Object.entries(loanApplication.ATTR1);
        const chunkSize = 4;
        const chunks = [];
        for (let i = 0; i < attributes.length; i += chunkSize) {
          const chunk = attributes.slice(i, i + chunkSize);
          chunks.push(
            <div className="mt-1 grid grid-cols-4 text-xs leading-5 text-gray-500" key={i}>
              {chunk.map(([key, value], index) => {
                const label = getLabel(key);
                return label ? (
                  <p className="whitespace-nowrap" key={index}>
                    <span className='text-xs mr-2'>{label}:</span>
                    <span className='text-sm font-bold'>{value}</span>
                  </p>
                ) : null;
              })}
            </div>
          );
        }
        return chunks;
    };
    return (
        <>
        <div className="border-b border-gray-200 bg-white px-4 py-3 mb-5 sm:px-6">
            <div className="-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                <div className="ml-4 mt-4">
                <h3 className="text-base font-semibold leading-6 text-gray-900">List Loans</h3>
                <p className="mt-1 text-sm text-gray-500">
                    Listing all your loans here. Click on a loan to view details.
                </p>
                </div>
                <div className="ml-4 mt-4 flex-shrink-0">
                <button
                    onClick={() => navigate('/home/apply_loan')}
                    type="button"
                    className="relative inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                    +Apply for Loan
                </button>
                </div>
            </div>
        </div>
        <ul
        role="list"
        className="divide-y divide-gray-100 overflow-hidden bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl"
        >
        {loanApplications.map((loanApplication) => (
            <li key={loanApplication.sk} className="relative flex justify-between gap-x-6 px-4 py-5 hover:bg-gray-50 sm:px-6 hover:cursor-pointer" onClick={() => {handleClick(loanApplication)}}>
                <div className="min-w-0">
                    {<div className="flex items-start gap-x-3 mb-3" key="1">
                        <p className="text-sm font-semibold leading-6 text-gray-900">Application ID: {loanApplication.ATTR1.id}</p>
                        <p
                        className={classNames(
                            statuses['Sanctioned'],
                            'mt-0.5 whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset',
                        )}
                        >
                        {capitalizeAndSpace(loanApplication.ATTR1.status)}
                        </p>
                        <div className="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500" key="4">
                        <p className="whitespace-nowrap italic">
                            Last Edited {readableDate(loanApplication.modified_datetime)}
                        </p>
                        <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 fill-current">
                            <circle r={1} cx={1} cy={1} />
                        </svg>
                        <p className="truncate italic">Modified by {loanApplication.ATTR1.display_name}</p>
                        </div>
                    </div>}
                    <div className="mb-2">
                        {renderChunks(loanApplication)}
                    </div>
                </div>
            </li>
        ))}
        </ul>
        </>
    )
 }
 function ApplyLoanScreen(){
    return CreateForm(form)
}
 
export { ListLoanScreen, ApplyLoanScreen }